import { render, staticRenderFns } from "./ProgAlert.vue?vue&type=template&id=45794161&scoped=true&"
import script from "./ProgAlert.vue?vue&type=script&lang=ts&"
export * from "./ProgAlert.vue?vue&type=script&lang=ts&"
import style0 from "./ProgAlert.vue?vue&type=style&index=0&id=45794161&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45794161",
  null
  
)

export default component.exports